module.exports = __webpack_public_path__ + "img/SM.3dc23e81.png";